import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {PlanModel, PlanGridModel} from '../../models/plan';
import {MatDialog} from '@angular/material';
import {
  ViewCoverageDialogComponent
} from './view-coverage/view-coverage.component';
import {
  ExtendedAreaDialogComponent
} from './extended-area/extended-area.component';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';


@Component({
  selector: 'app-plan-selection',
  templateUrl: './plan-selection.component.html',
  styleUrls: ['./plan-selection.component.css']
})
export class PlanSelectionComponent implements OnChanges {
  @Input() plans: PlanModel[];
  @Input() selectedPlan: PlanModel;
  @Input() useMonthly: boolean;
  @Input() selectDelay = 750;
  @Input() zipCode: string;
  @Input() state: string;

  @Output() selectedPlanChange: EventEmitter<PlanModel>;
  @Output() useMonthlyChange: EventEmitter<boolean>;

  mobileCompareVisible = false;
  currentMobileCompareSlide = 0;
  planGrid: PlanGridModel;

  private swipeCoord?:[number, number];
  private swipeTime?: number;

  compareMobile() {
    this.mobileCompareVisible = !this.mobileCompareVisible;

    if (this.mobileCompareVisible) {
      this.updateWidths();
      this.setUniqueStandardItems();
    }
  }

  get outerContainerWidth() { return window.outerWidth + 'px'; }

  updateWidths() {
    setTimeout(() => {
      const width = (window.outerWidth / 2) - 11;

      const elements = document.getElementsByClassName('compare-column');
      for (let i = 0; i < elements.length; i++) {
        const element: any = elements[i];
        element.style.width = width + 'px';
      }

      const buttonLoc = window.innerHeight / 2;

      document.getElementById('comparePrev').style.top = buttonLoc + 'px';
      document.getElementById('compareNext').style.top = buttonLoc + 'px';
    });
  }

  swipe(e: TouchEvent, when: string): void {
    const coord:[number, number] =
        [e.changedTouches[0].pageX, e.changedTouches[0].pageY];
    const time = new Date().getTime();

    if (when === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else if (when === 'end') {
      const direction =
          [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const duration = time - this.swipeTime;

      if (duration < 1000 && Math.abs(direction[0]) > 60 &&
          Math.abs(direction[0]) > Math.abs(direction[1] * 3)) {
        const swipe = direction[0] < 0 ? 'next' : 'previous';
        if (swipe === 'next') {
          this.nextCompareSlide();
        } else {
          this.prevCompareSlide();
        }
      }
    }
  }

  updateWidthsAndPerserveScroll() {
    this.updateWidths();
    this.currentMobileCompareSlide = this.mobileCompareSlides;
    this.setUniqueStandardItemsDelayed();
  }

  get mobileCompareSlides(): number {
    if (!this.planGrid) {
      return 0;
    }

    let num = Math.ceil((this.selectedPlans.length + 1) / 2);
    if (this.selectedPlans.length % 2 === 0) {
      num--;
    }
    return num;
  }

  get mobileSlideTranslate(): string {
    if (!document.getElementById('measureContainer')) {
      return;
    }

    const width = window.outerWidth / 2;
    return 'translate(' + (-(this.currentMobileCompareSlide * width)) +
           'px, 0px)';
  }

  removePlanComparisonItem(item: PlanModel) {
    item.removing = true;
    setTimeout(() => {
      item.removing = false;
      item.selected = false;
      console.log(this.selectedPlans);
      this.setUniqueStandardItems();
    }, 500);
  }

  nextCompareSlide() {
    if (this.currentMobileCompareSlide < this.mobileCompareSlides) {
      this.currentMobileCompareSlide++;
    }
  }

  prevCompareSlide() {
    if (this.currentMobileCompareSlide > 0) {
      this.currentMobileCompareSlide--;
    }
  }

  showCoverage(item) {
    this.dialog.open(ViewCoverageDialogComponent,
                     {data: item.salesItemCoverageId});
  }

  showExtendedArea(state) {
    this.dialog.open(ExtendedAreaDialogComponent,
      { data: state });
  }

  constructor(public dialog: MatDialog,
              private customerPortalService: RealtorPortalService) {
    this.selectedPlanChange = new EventEmitter();
    this.useMonthlyChange = new EventEmitter();
  }

  selectPlan(plan: PlanModel) {
    this.selectedPlan = plan;

    this.selectedPlanChange.emit(plan);
  }

  selectPlanDelayed(plan: PlanModel) {
    this.selectedPlan = plan;
    setTimeout(() => this.selectPlan(plan), this.selectDelay);
  }

  updateMonthly($event) { this.useMonthlyChange.emit($event); }

  get selectedPlans(): PlanModel[] {
    return this.planGrid.plans.filter(i => i.selected);
  }

  setUniqueStandardItemsDelayed() {
    setTimeout(() => this.setUniqueStandardItems());
  }

  setUniqueStandardItems() {
    let index = 0;
    this.selectedPlans.forEach(plan => {

      // const otherPlan = this.selectedPlans[index + 1];
      // if (otherPlan != null) {
      //   plan.standardItems.forEach(si => {
      //     let wasMatched = false;

      //     const matchedItem = otherPlan.standardItems.filter(
      //         osi => osi.salesItemId === si.salesItemId ||
      //                osi.name === si.name)[0];
      //     if (matchedItem != null) {
      //       wasMatched = true;
      //     }

      //     si.unique = !wasMatched;
      //   });
      // }

      const otherPlans = this.selectedPlans.filter(
          i => i !== plan);
      plan.standardItems.forEach(si => {
        let wasMatched = false;


        otherPlans.forEach(otherPlan => {
          const matchedItem = otherPlan.standardItems.filter(
              osi => osi.salesItemId === si.salesItemId ||
                     osi.name === si.name)[0];
          if (matchedItem != null) {
            wasMatched = true;
          }
        });
        si.unique = !wasMatched;
      });
      index++;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.plans) {
      this.planGrid = PlanGridModel.getPlanGridModel(this.plans);
    }
  }
}
